(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scent-quiz]').forEach(function (quiz) {
    if (quiz.dataset.quizInitialized === 'true') return;
    quiz.dataset.quizInitialized = 'true';
    var questions = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-question]'));
    var progressText = quiz.querySelector('[data-quiz-progress-text]');
    var progressBar = quiz.querySelector('[data-quiz-progress-bar]');
    var resultPanel = quiz.querySelector('[data-quiz-result]');
    var productDataElement = quiz.querySelector('[data-scent-product-data]');
    var products = [];
    try { products = JSON.parse(productDataElement.textContent); } catch (error) { return; }
    if (!products.length) return;
    var currentQuestion = 0;
    var traitScores = {};
    var choiceHistory = [];

    function playEntrance(panel) {
      if (!panel) return;
      panel.classList.remove('ff-scent-quiz__panel--enter');
      void panel.offsetWidth;
      panel.classList.add('ff-scent-quiz__panel--enter');
    }

    function showQuestion(index, moveFocus) {
      questions.forEach(function (question, questionIndex) { question.hidden = questionIndex !== index; });
      currentQuestion = index;
      progressText.textContent = 'Chapter ' + (index + 1) + ' of ' + questions.length;
      progressBar.style.width = (((index + 1) / questions.length) * 100) + '%';
      playEntrance(questions[index]);
      if (moveFocus) { var firstAnswer = questions[index].querySelector('[data-quiz-answer]'); if (firstAnswer) firstAnswer.focus(); }
    }

    function overlapCount(productTraits, answerTraits) {
      return answerTraits.reduce(function (total, trait) { return total + (productTraits.indexOf(trait) !== -1 ? 1 : 0); }, 0);
    }

    function chooseWinner() {
      var ranked = products.map(function (product, productIndex) {
        var score = product.traits.reduce(function (total, trait) { return total + (traitScores[trait] || 0); }, 0);
        var recentAffinity = choiceHistory.reduce(function (total, traits, index) { return total + overlapCount(product.traits, traits) * (index + 1); }, 0);
        return { product: product, score: score, recentAffinity: recentAffinity, productIndex: productIndex };
      });
      ranked.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (b.recentAffinity !== a.recentAffinity) return b.recentAffinity - a.recentAffinity;
        return a.productIndex - b.productIndex;
      });
      return ranked[0].product;
    }

    function showResult() {
      questions.forEach(function (question) { question.hidden = true; });
      progressText.textContent = 'Your Elaris match is ready';
      progressBar.style.width = '100%';
      var product = chooseWinner();
      var image = resultPanel.querySelector('[data-result-image]');
      var heading = resultPanel.querySelector('[data-result-heading]');
      var profile = resultPanel.querySelector('[data-result-profile]');
      var lore = resultPanel.querySelector('[data-result-lore]');
      var notes = resultPanel.querySelector('[data-result-notes]');
      var link = resultPanel.querySelector('[data-result-link]');
      heading.textContent = product.title;
      profile.textContent = 'PROFILE · ' + product.profile;
      lore.textContent = product.lore;
      notes.textContent = product.notes;
      link.href = product.url;
      link.textContent = 'Explore ' + product.title;
      if (product.image) { image.src = product.image; image.alt = product.title + ' candle'; image.hidden = false; } else { image.hidden = true; }
      resultPanel.hidden = false;
      playEntrance(resultPanel);
      heading.focus();
    }

    quiz.addEventListener('click', function (event) {
      var answer = event.target.closest('[data-quiz-answer]');
      if (answer && quiz.contains(answer)) {
        var traits = (answer.dataset.traits || '').split(/\s+/).filter(Boolean);
        var weight = parseInt(answer.dataset.weight || '1', 10);
        traits.forEach(function (trait) { traitScores[trait] = (traitScores[trait] || 0) + weight; });
        choiceHistory.push(traits);
        if (currentQuestion < questions.length - 1) showQuestion(currentQuestion + 1, true); else showResult();
        return;
      }
      var restart = event.target.closest('[data-quiz-restart]');
      if (restart && quiz.contains(restart)) {
        traitScores = {};
        choiceHistory = [];
        resultPanel.hidden = true;
        showQuestion(0, true);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
